var map = {
	"./horizontal/en/color-black.svg": 581,
	"./horizontal/en/color-white.svg": 582,
	"./horizontal/en/mono-black.svg": 583,
	"./horizontal/uk/color-black.svg": 584,
	"./horizontal/uk/color-white.svg": 585,
	"./horizontal/uk/mono-black.svg": 586,
	"./icon/default/lun_icon.svg": 587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;